module.exports = __webpack_public_path__ + "media/application/images/ui/logo-no-strap-header@x2-b9c9a0c957762ddb93af874412d38f7a.png";